import React from "react";
import i18n from "../../constants/i18n";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import Et3PageTitle from "../../core/et3-page-title/index";
import getCoreHistoryStore from "../../stores/core/core-history-store";
import ET3PageDiv from "../../core/et3-page-div";
import Et3Margin from "../../core/et3-ui/ET3Margin";
import InvestigationCasesForm from "./investigation-cases-form";
import InvestigationCasesData from "./investigation-cases-data";
import { useLocation } from "react-router-dom";
import { reduce } from "et3-type-guards";
import getInvestigationCasesStore from "../../stores/investigation-cases-store";

const InvestigationCases = withLiteObserverAndTheme(() => {
  const location = useLocation();
  React.useEffect(() => {
    const search = reduce(() => location.search, "");
    getCoreHistoryStore().setPageName(
      "INVESTIGATION_CASES",
      "INVESTIGATION_CASES"
    );
    getInvestigationCasesStore().checkURLSearch(search);
  }, []);

  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{}}
    >
      <Et3PageTitle
        title={i18n.get("INVESTIGATION_CASES")}
        subTitle={i18n.get("TBW")}
        withRefresh={false}
        withHelper={false}
        onPress={() => {}}
      />
      <InvestigationCasesForm />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <InvestigationCasesData />
    </ET3PageDiv>
  );
});
export default InvestigationCases;
